import api from "!../../../../../../releases/3a58eae59727a019b648a1f37390bfdbc40411cf/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/3a58eae59727a019b648a1f37390bfdbc40411cf/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/3a58eae59727a019b648a1f37390bfdbc40411cf/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/3a58eae59727a019b648a1f37390bfdbc40411cf/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};